require('../../modules/es.set');
require('../../modules/esnext.set.add-all');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Set', 'addAll');
